import { useEffect, useState } from "react";
import useFirestore from "../common/useFirestore";
import useCrypto from "../common/useCrypto";
import useFirebaseAuth from "../common/useFirebaseAuth";
import { useNavigate } from "react-router-dom";

function useUserProfile(){
    const uid = sessionStorage.getItem("uid");
    const {logout} = useFirebaseAuth();
    const {readFirestoreWithQuery}= useFirestore();
    const {decrypto} = useCrypto();
    const navigate = useNavigate();
    const [user, setUser] = useState({
        name:"",
        id:"",
        tel:"",
    })

    useEffect(() => {
        getUserData();
    }, [uid])

    const getUserData = async() => {
        const user = await readFirestoreWithQuery("Account", {field:"uid", operator:"==", data:uid}).then(res => {
            if(!res.empty){
                const data = res.docs[0].data();
                const decrypted_tel = decrypto(data.tel);
                return {name:data.name, id:data.id, tel:decrypted_tel};
            }
        });
        setUser(user);
    }

    const onLogoutClickHandler = () => {
        logout().then(res =>{
            if(res){
                sessionStorage.removeItem("uid");
                navigate("/", {replace:true});  
            }
        })
    }

    return{user, onLogoutClickHandler}
}

export default useUserProfile;